import { CorpusId } from '../../models/aliases';
import { events } from '../../analytics/events';
import { useTrackedHandler } from '../../hooks/useTracking';

import { Link, Typography } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import styled from 'styled-components';

interface PaperTitleProps {
  title: string;
  corpusId: CorpusId;
}

export function PaperTitle(props: PaperTitleProps): JSX.Element {
  const { title, corpusId } = props;

  const reportTrackingOnClick = useTrackedHandler(
    events.navigation.PaperLinkClicked,
    (): void => {},
    () => ({ corpusId }),
  );

  return (
    <StyledTypography>
      <Link
        href={`https://api.semanticscholar.org/CorpusId:${corpusId}`}
        target="_blank"
        underline="hover"
        onClick={reportTrackingOnClick}
      >
        {title}
        <OpenInNewIcon />
      </Link>
    </StyledTypography>
  );
}

const StyledTypography = styled(Typography).attrs({
  variant: 'h5',
})`
  margin-bottom: 0px;
  & .MuiLink-root {
    font-weight: 700;
  }
  & .MuiSvgIcon-root {
    font-size: 16px;
    margin: 0px 0px 2px 6px;
    vertical-align: middle;
  }
`;
